import { render, staticRenderFns } from "./ReviewsHeader.vue?vue&type=template&id=303ed832&"
import script from "./ReviewsHeader.vue?vue&type=script&lang=js&"
export * from "./ReviewsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports